import * as React from 'react';
import { useSelector } from 'react-redux';
import { createSelector } from '@reduxjs/toolkit';

import { IApplicationState } from '../../types/redux';
import { COMPONENTS } from './componentsMapping';

import { LinksBlock } from '../../components/LinksBlock';

const selectAvailableLinksComponents = createSelector(
  (state: IApplicationState) => state,
  state =>
    COMPONENTS.filter(({ availability }) => !availability || availability(state)).map(
      ({ key, component: Component }) => <Component linkKey={key} key={`link-${key}`} />,
    ),
);

export const LinksBlockContainer: React.FC = () => {
  const availableLinksComponents = useSelector(selectAvailableLinksComponents);

  return <LinksBlock links={availableLinksComponents} />;
};
